import { useState, useCallback } from "react";
import * as api from "../../api";

/* PASO 4 (F3B) — Redes sociales (público + admin). Movido VERBATIM de App.js. */
export function useAdminSocial(showToast) {
  const [socialNetworks, setSocialNetworks] = useState([]);
  const [adminSocialNets, setAdminSocialNets] = useState([]);
  const [snForm, setSnForm] = useState({ id: null, name: "", url: "", icon: "" });
  const [snBusy, setSnBusy] = useState(false);

  const loadSocialNetworksPublic = useCallback(async () => {
    try {
      const list = await api.listSocialNetworks();
      setSocialNetworks(list);
    } catch (e) { console.warn("public social networks load failed:", e); }
  }, []);

  const loadAdminSocialNets = useCallback(async () => {
    try {
      const list = await api.adminListSocialNetworks();
      setAdminSocialNets(list);
    } catch (err) {
      showToast("Error", err.message || "No se pudieron cargar", "error");
    }
  }, [showToast]);

  const handleSaveSocial = async (e) => {
    e.preventDefault();
    const name = snForm.name.trim();
    const url = snForm.url.trim();
    if (!name || !url) {
      showToast("Error", "Nombre y URL son obligatorios", "error");
      return;
    }
    setSnBusy(true);
    try {
      const body = { name, url, icon: snForm.icon.trim() || null };
      if (snForm.id) {
        const updated = await api.adminUpdateSocialNetwork(snForm.id, body);
        setAdminSocialNets(list => list?.map(s => s.id === updated.id ? updated : s));
      } else {
        const created = await api.adminCreateSocialNetwork({ ...body, active: true });
        setAdminSocialNets(list => [...list, created]);
      }
      setSnForm({ id: null, name: "", url: "", icon: "" });
      loadSocialNetworksPublic();
      showToast("Red social guardada", `${name} actualizada`, "success");
    } catch (err) {
      showToast("Error", err.message || "No se pudo guardar", "error");
    } finally {
      setSnBusy(false);
    }
  };

  const handleToggleSocial = async (net) => {
    try {
      const updated = await api.adminUpdateSocialNetwork(net.id, { active: !net.active });
      setAdminSocialNets(list => list?.map(s => s.id === updated.id ? updated : s));
      loadSocialNetworksPublic();
    } catch (err) {
      showToast("Error", err.message || "No se pudo actualizar", "error");
    }
  };

  const handleDeleteSocial = async (net) => {
    if (!window.confirm(`¿Eliminar la red social "${net.name}"?`)) return;
    try {
      await api.adminDeleteSocialNetwork(net.id);
      setAdminSocialNets(list => list?.filter(s => s.id !== net.id));
      loadSocialNetworksPublic();
      showToast("Eliminada", net.name, "success");
    } catch (err) {
      showToast("Error", err.message || "No se pudo eliminar", "error");
    }
  };

  return {
    socialNetworks, adminSocialNets, snForm, setSnForm, snBusy,
    loadSocialNetworksPublic, loadAdminSocialNets,
    handleSaveSocial, handleToggleSocial, handleDeleteSocial,
  };
}
